import { useMutation, useQueryClient } from "@tanstack/react-query";
import { trainerFilesApi } from "api/trainers/trainerFilesApi";
import { QUERIES_KEYS } from "queries";

export const useAddTrainerFileCommentAdmin = (trainerId: number, fileId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: string) => trainerFilesApi.addComment(trainerId, fileId, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERIES_KEYS.TRAINER_FILE_COMMENTS(trainerId, fileId) });
      queryClient.invalidateQueries({ queryKey: QUERIES_KEYS.TRAINER_FILES(trainerId) });
    },
  });
};
